module.exports = __webpack_public_path__ + "static/media/seminary.e5036e2b.jpg";